import { Layout } from 'react-admin';
import { CustomAppBar } from './CustomAppBar';
import React from 'react';

const MyLayout = props => <Layout sx={{ '& .RaLayout-appFrame': { marginTop: '4rem' } }} {...props} appBar={CustomAppBar}/>;

export default MyLayout;